import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import { useStores } from 'hooks';

const backgroundColor = (props) => {
  if (props.okayToSell) return '#21BA45';
  if (props.disabled) return '#e7e7e7';
  if (props.doNotSell) return '#DB2828';
  return '#FBCC08';
};

const Label = styled.label`
  margin: 20px 0px 0px 0px;
  color: #000;
  font-size: 1.5em;
  border-bottom: 1px solid gray;
`;

const Container = styled.div`
  background-color: ${(props) => backgroundColor(props)};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 95%;
  margin: 10px;
  border: 1px solid gray;
  padding: 20px;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 2em;
  color: #fff;
  box-sizing: border-box;
  & div {
    text-align: center;
    width: 100%;
    margin: 5px 0px;
  }
`;

const NotificationContainer = () => {
  const {
    BidStore: { auction },
    MessageStore: {
      sellerAction,
    },
  } = useStores();

  const { lotNumber } = auction;

  const [sellerMessage, setSellerMessage] = useState(null);

  useEffect(() => {
    if (sellerAction) {
      if (sellerAction.action.includes('CANCEL')) {
        setSellerMessage(null);
        return;
      }

      setSellerMessage(sellerAction.action);
    }
  }, [sellerAction]);

  useEffect(() => {
    setSellerMessage(null);
  }, [lotNumber]);

  if (!sellerMessage) {
    return null;
  }

  return (
    <>
      <Label>Seller Notification</Label>
      <Container doNotSell={sellerMessage && sellerMessage.includes('DO NOT SELL')} okayToSell={sellerMessage && sellerMessage.includes('OK TO SELL')}>
        <div>{sellerMessage}</div>
      </Container>
    </>
  );
};

export default observer(NotificationContainer);
